import React from "react";
import HeroSlider from "./HeroSlider";
import GamShow from "./GamShow";
import JackPotSlider from "./JackPotSlider";
import { JackpotIcon, ProviderIcon } from "../../helper/Icons";
import { CasinoIcon, LotteryIcon } from "../../helper/Icon2";
import LotterySlider from "./LotterySlider";
import {
  CasinoSlotData,
  LotteryUpcomingData,
  ProviderData,
  SlotTabData,
} from "../../helper/Helper";
import DownloadApp from "./DownloadApp";
import Provider from "./Provider";
import AcceptPayments from "./AcceptPayments";
import About from "./About";
import TextSlider from "../../common/TextSlider";
import SwiperSlider from "../../common/SwiperSlider";

function Home() {
  return (
    <>
      <HeroSlider />
      <TextSlider
        text={
          "Casino - Semu Pasarna Togel Terpopuler & Game Slot Terbaik - Proses Deposit 1 Detik "
        }
      />
      <GamShow />
      <JackPotSlider
        icon={<JackpotIcon />}
        sectionHeading={"Jackpot"}
        TabData={SlotTabData}
        right={false}
        className={"my-4 pt-2"}
      />
      <SwiperSlider
        sectionHeading={"Casino"}
        icon={<CasinoIcon />}
        data={CasinoSlotData}
      />

      <LotterySlider
        icon={<LotteryIcon />}
        sectionHeading={" Lottery Upcoming Draw"}
        data={LotteryUpcomingData}
      />

      <About />
      <DownloadApp />
      <AcceptPayments />
      <Provider
        icon={<ProviderIcon />}
        sectionHeading={"Provider"}
        TabData={ProviderData}
        className={"my-4 pt-2"}
        autoplay={true}
      />
    </>
  );
}

export default Home;
